import React from 'react';

const StatSkeleton = () => {
  return (
      <div className='stats skeleton'>
        <div className="stat">
          <div className='img-icon'/>
          <div className="content">
            <div className="number"/>
            <div className="text"/>
          </div>
        </div>
        <div className="stat">
          <div className='img-icon'/>
          <div className="content">
            <div className="number"/>
            <div className="text"/>
          </div>
        </div>
        <div className="stat">
          <div className='img-icon'/>
          <div className="content">
            <div className="number"/>
            <div className="text"/>
          </div>
        </div>
      </div>
  )
};


export default StatSkeleton;